import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * ScrollProgress - Thin progress bar at the top of the page
 * Shows reading progress (0-100%) as user scrolls down
 * Used by: Medium, Notion, Substack
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const MotionDiv = motion.div;

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[3px] bg-gray-200 z-[9999] overflow-hidden rounded-full"
      aria-hidden="true"
    >
      <MotionDiv
        className="h-full bg-gradient-to-r from-[#93C5FD] via-[#60A5FA] to-[#60A5FA] origin-left rounded-full"
        style={{ scaleX }}
      />
    </div>
  );
}
